import { render, staticRenderFns } from "./CategorySorts.vue?vue&type=template&id=46d5c8ed&scoped=true&name=the-sorts&"
import script from "./CategorySorts.vue?vue&type=script&lang=js&"
export * from "./CategorySorts.vue?vue&type=script&lang=js&"
import style0 from "./CategorySorts.vue?vue&type=style&index=0&id=46d5c8ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d5c8ed",
  null
  
)

/* custom blocks */
import block0 from "./CategorySorts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports